import { RowFileTypeEnums } from './Enums/RowFileTypeEnums';
import { CorporateDocument, File } from './types';

export type DeepLinkTarget = {
  document: CorporateDocument;
  file: File | undefined;
};

export const findDeepLinkTarget = (
  documents: CorporateDocument[],
  documentId: string | null,
): DeepLinkTarget | null => {
  if (documentId === null) {
    return null;
  }
  const document = documents.find((d) => d.id === documentId);
  if (!document) {
    return null;
  }
  return { document, file: document.files?.[0] };
};

export const isDocumentMulti = (type: string) =>
  type === RowFileTypeEnums.Multi;

export const isFolder = (type: string) => type === RowFileTypeEnums.Folder;

export const replaceUnderscores = (str: string, replaceValue: string = ' ') => {
  return str.replace(/_/g, replaceValue);
};
